// Liste des pays (source : Pays-20260827.txt fourni par utilisateur)
export const COUNTRIES = [
  {
    "name": "AFGHANISTAN",
    "code": "AF"
  },
  {
    "name": "AFRIQUE DU SUD",
    "code": "ZA"
  },
  {
    "name": "ALBANIE",
    "code": "AL"
  },
  {
    "name": "ALGERIE",
    "code": "DZ"
  },
  {
    "name": "ALLEMAGNE",
    "code": "DE"
  },
  {
    "name": "ANDORRE",
    "code": "AD"
  },
  {
    "name": "ANGOLA",
    "code": "AO"
  },
  {
    "name": "ANGUILLA",
    "code": "AI"
  },
  {
    "name": "ANTARCTIQUE",
    "code": "AQ"
  },
  {
    "name": "ANTIGUA ET BARBUDA",
    "code": "AG"
  },
  {
    "name": "ANTILLES NEERLANDAISES",
    "code": "AN"
  },
  {
    "name": "ARABIE SAOUDITE",
    "code": "SA"
  },
  {
    "name": "ARGENTINE",
    "code": "AR"
  },
  {
    "name": "ARMENIE",
    "code": "AM"
  },
  {
    "name": "ARUBA",
    "code": "AW"
  },
  {
    "name": "AUSTRALIE",
    "code": "AU"
  },
  {
    "name": "AUTRICHE",
    "code": "AT"
  },
  {
    "name": "AZERBAIDJAN",
    "code": "AZ"
  },
  {
    "name": "BAHAMAS",
    "code": "BS"
  },
  {
    "name": "BAHREIN",
    "code": "BH"
  },
  {
    "name": "BANGLADESH",
    "code": "BD"
  },
  {
    "name": "BARBADE",
    "code": "BB"
  },
  {
    "name": "BELARUS",
    "code": "BY"
  },
  {
    "name": "BELGIQUE",
    "code": "BE"
  },
  {
    "name": "BELIZE",
    "code": "BZ"
  },
  {
    "name": "BENIN",
    "code": "BJ"
  },
  {
    "name": "BERMUDES",
    "code": "BM"
  },
  {
    "name": "BHOUTAN",
    "code": "BT"
  },
  {
    "name": "BOLIVIE",
    "code": "BO"
  },
  {
    "name": "BOSNIE HERZEGOVINE",
    "code": "BA"
  },
  {
    "name": "BOTSWANA",
    "code": "BW"
  },
  {
    "name": "BRESIL",
    "code": "BR"
  },
  {
    "name": "BRUNEI DARUSSALAM",
    "code": "BN"
  },
  {
    "name": "BULGARIE",
    "code": "BG"
  },
  {
    "name": "BURKINA FASO",
    "code": "BF"
  },
  {
    "name": "BURUNDI",
    "code": "BI"
  },
  {
    "name": "CAMBODGE",
    "code": "KH"
  },
  {
    "name": "CAMEROUN",
    "code": "CM"
  },
  {
    "name": "CANADA",
    "code": "CA"
  },
  {
    "name": "CAP VERT",
    "code": "CV"
  },
  {
    "name": "CHILI",
    "code": "CL"
  },
  {
    "name": "CHINE",
    "code": "CN"
  },
  {
    "name": "CHYPRE",
    "code": "CY"
  },
  {
    "name": "COLOMBIE",
    "code": "CO"
  },
  {
    "name": "COMORES",
    "code": "KM"
  },
  {
    "name": "CONGO",
    "code": "CG"
  },
  {
    "name": "COSTA RICA",
    "code": "CR"
  },
  {
    "name": "COTE D'IVOIRE",
    "code": "CI"
  },
  {
    "name": "CROATIE",
    "code": "HR"
  },
  {
    "name": "CUBA",
    "code": "CU"
  },
  {
    "name": "DANEMARK",
    "code": "DK"
  },
  {
    "name": "DJIBOUTI",
    "code": "DJ"
  },
  {
    "name": "DOMINIQUE",
    "code": "DM"
  },
  {
    "name": "EGYPTE",
    "code": "EG"
  },
  {
    "name": "EL SALVADOR",
    "code": "SV"
  },
  {
    "name": "EMIRATS ARABES UNIS",
    "code": "AE"
  },
  {
    "name": "EQUATEUR",
    "code": "EC"
  },
  {
    "name": "ERYTHREE",
    "code": "ER"
  },
  {
    "name": "ESPAGNE",
    "code": "ES"
  },
  {
    "name": "ESTONIE",
    "code": "EE"
  },
  {
    "name": "ETATS FEDERES DE MICRONESIE",
    "code": "FM"
  },
  {
    "name": "ETATS-UNIS",
    "code": "US"
  },
  {
    "name": "ETHIOPIE",
    "code": "ET"
  },
  {
    "name": "EX-REPUBLIQUE YOUGOSLAVE DE MACEDOINE",
    "code": "MK"
  },
  {
    "name": "FEDERATION DE RUSSIE",
    "code": "RU"
  },
  {
    "name": "FIDJI",
    "code": "FJ"
  },
  {
    "name": "FINLANDE",
    "code": "FI"
  },
  {
    "name": "FRANCE",
    "code": "FR"
  },
  {
    "name": "GABON",
    "code": "GA"
  },
  {
    "name": "GAMBIE",
    "code": "GM"
  },
  {
    "name": "GEORGIE",
    "code": "GE"
  },
  {
    "name": "GEORGIE DU SUD ET ILES SANDWICH DU SUD",
    "code": "GS"
  },
  {
    "name": "GHANA",
    "code": "GH"
  },
  {
    "name": "GIBRALTAR",
    "code": "GI"
  },
  {
    "name": "GRECE",
    "code": "GR"
  },
  {
    "name": "GRENADE",
    "code": "GD"
  },
  {
    "name": "GROENLAND",
    "code": "GL"
  },
  {
    "name": "GUADELOUPE",
    "code": "GP"
  },
  {
    "name": "GUAM",
    "code": "GU"
  },
  {
    "name": "GUATEMALA",
    "code": "GT"
  },
  {
    "name": "GUERNESEY",
    "code": "GG"
  },
  {
    "name": "GUINEE",
    "code": "GN"
  },
  {
    "name": "GUINEE BISSAU",
    "code": "GW"
  },
  {
    "name": "GUINEE EQUATORIALE",
    "code": "GQ"
  },
  {
    "name": "GUYANA",
    "code": "GY"
  },
  {
    "name": "GUYANE FRANCAISE",
    "code": "GF"
  },
  {
    "name": "HAITI",
    "code": "HT"
  },
  {
    "name": "HONDURAS",
    "code": "HN"
  },
  {
    "name": "HONG KONG",
    "code": "HK"
  },
  {
    "name": "HONGRIE",
    "code": "HU"
  },
  {
    "name": "ILE BOUVET",
    "code": "BV"
  },
  {
    "name": "ILE CHRISTMAS",
    "code": "CX"
  },
  {
    "name": "ILE DE MAN",
    "code": "IM"
  },
  {
    "name": "ILE HEARD ET ILES MCDONALD",
    "code": "HM"
  },
  {
    "name": "ILE NORFOLK",
    "code": "NF"
  },
  {
    "name": "ILES ALAND",
    "code": "AX"
  },
  {
    "name": "ILES CAIMANES",
    "code": "KY"
  },
  {
    "name": "ILES COCOS",
    "code": "CC"
  },
  {
    "name": "ILES COOK",
    "code": "CK"
  },
  {
    "name": "ILES FALKLAND",
    "code": "FK"
  },
  {
    "name": "ILES FEROE",
    "code": "FO"
  },
  {
    "name": "ILES MARIANNES DU NORD",
    "code": "MP"
  },
  {
    "name": "ILES MARSHALL",
    "code": "MH"
  },
  {
    "name": "ILES MINEURES ELOIGNEES DES ETATS-UNIS",
    "code": "UM"
  },
  {
    "name": "ILES SALOMON",
    "code": "SB"
  },
  {
    "name": "ILES TURKS ET CAIQUES",
    "code": "TC"
  },
  {
    "name": "ILES VIERGES BRITANNIQUES",
    "code": "VG"
  },
  {
    "name": "ILES VIERGES DES ETATS-UNIS",
    "code": "VI"
  },
  {
    "name": "INDE",
    "code": "IN"
  },
  {
    "name": "INDONESIE",
    "code": "ID"
  },
  {
    "name": "IRAQ",
    "code": "IQ"
  },
  {
    "name": "IRLANDE",
    "code": "IE"
  },
  {
    "name": "ISLANDE",
    "code": "IS"
  },
  {
    "name": "ISRAEL",
    "code": "IL"
  },
  {
    "name": "ITALIE",
    "code": "IT"
  },
  {
    "name": "JAMAHIRIYA ARABE LIBYENNE",
    "code": "LY"
  },
  {
    "name": "JAMAIQUE",
    "code": "JM"
  },
  {
    "name": "JAPON",
    "code": "JP"
  },
  {
    "name": "JERSEY",
    "code": "JE"
  },
  {
    "name": "JORDANIE",
    "code": "JO"
  },
  {
    "name": "KAZAKHSTAN",
    "code": "KZ"
  },
  {
    "name": "KENYA",
    "code": "KE"
  },
  {
    "name": "KIRGHIZISTAN",
    "code": "KG"
  },
  {
    "name": "KIRIBATI",
    "code": "KI"
  },
  {
    "name": "KOWEIT",
    "code": "KW"
  },
  {
    "name": "LA REPUBLIQUE DEMOCRATIQUE DU CONGO",
    "code": "CD"
  },
  {
    "name": "LESOTHO",
    "code": "LS"
  },
  {
    "name": "LETTONIE",
    "code": "LV"
  },
  {
    "name": "LIBAN",
    "code": "LB"
  },
  {
    "name": "LIBERIA",
    "code": "LR"
  },
  {
    "name": "LIECHTENSTEIN",
    "code": "LI"
  },
  {
    "name": "LITUANIE",
    "code": "LT"
  },
  {
    "name": "LUXEMBOURG",
    "code": "LU"
  },
  {
    "name": "MACAO",
    "code": "MO"
  },
  {
    "name": "MADAGASCAR",
    "code": "MG"
  },
  {
    "name": "MALAISIE",
    "code": "MY"
  },
  {
    "name": "MALAWI",
    "code": "MW"
  },
  {
    "name": "MALDIVES",
    "code": "MV"
  },
  {
    "name": "MALI",
    "code": "ML"
  },
  {
    "name": "MALTE",
    "code": "MT"
  },
  {
    "name": "MAROC",
    "code": "MA"
  },
  {
    "name": "MARTINIQUE",
    "code": "MQ"
  },
  {
    "name": "MAURICE",
    "code": "MU"
  },
  {
    "name": "MAURITANIE",
    "code": "MR"
  },
  {
    "name": "MAYOTTE",
    "code": "YT"
  },
  {
    "name": "MEXIQUE",
    "code": "MX"
  },
  {
    "name": "MONACO",
    "code": "MC"
  },
  {
    "name": "MONGOLIE",
    "code": "MN"
  },
  {
    "name": "MONTENEGRO",
    "code": "ME"
  },
  {
    "name": "MONTSERRAT",
    "code": "MS"
  },
  {
    "name": "MOZAMBIQUE",
    "code": "MZ"
  },
  {
    "name": "MYANMAR",
    "code": "MM"
  },
  {
    "name": "NAMIBIE",
    "code": "NA"
  },
  {
    "name": "NAURU",
    "code": "NR"
  },
  {
    "name": "NEPAL",
    "code": "NP"
  },
  {
    "name": "NICARAGUA",
    "code": "NI"
  },
  {
    "name": "NIGER",
    "code": "NE"
  },
  {
    "name": "NIGERIA",
    "code": "NG"
  },
  {
    "name": "NIUE",
    "code": "NU"
  },
  {
    "name": "NORVEGE",
    "code": "NO"
  },
  {
    "name": "NOUVELLE-CALEDONIE",
    "code": "NC"
  },
  {
    "name": "NOUVELLE-ZELANDE",
    "code": "NZ"
  },
  {
    "name": "OMAN",
    "code": "OM"
  },
  {
    "name": "OUGANDA",
    "code": "UG"
  },
  {
    "name": "OUZBEKISTAN",
    "code": "UZ"
  },
  {
    "name": "PAKISTAN",
    "code": "PK"
  },
  {
    "name": "PALAOS",
    "code": "PW"
  },
  {
    "name": "PANAMA",
    "code": "PA"
  },
  {
    "name": "PAPOUASIE-NOUVELLE-GUINEE",
    "code": "PG"
  },
  {
    "name": "PARAGUAY",
    "code": "PY"
  },
  {
    "name": "PAYS-BAS",
    "code": "NL"
  },
  {
    "name": "PEROU",
    "code": "PE"
  },
  {
    "name": "PHILIPPINES",
    "code": "PH"
  },
  {
    "name": "PITCAIRN",
    "code": "PN"
  },
  {
    "name": "POLOGNE",
    "code": "PL"
  },
  {
    "name": "POLYNESIE FRANCAISE",
    "code": "PF"
  },
  {
    "name": "PORTO RICO",
    "code": "PR"
  },
  {
    "name": "PORTUGAL",
    "code": "PT"
  },
  {
    "name": "PROVINCE DE CHINE TAIWAN",
    "code": "TW"
  },
  {
    "name": "QATAR",
    "code": "QA"
  },
  {
    "name": "REP POPULAIRE DEMOCRATIQUE DE COREE",
    "code": "KP"
  },
  {
    "name": "REPUBLIQUE ARABE SYRIENNE",
    "code": "SY"
  },
  {
    "name": "REPUBLIQUE CENTRAFRICAINE",
    "code": "CF"
  },
  {
    "name": "REPUBLIQUE DE COREE",
    "code": "KR"
  },
  {
    "name": "REPUBLIQUE DE MOLDOVA",
    "code": "MD"
  },
  {
    "name": "REPUBLIQUE DEMOCRATIQUE POPULAIRE LAO",
    "code": "LA"
  },
  {
    "name": "REPUBLIQUE DOMINICAINE",
    "code": "DO"
  },
  {
    "name": "REPUBLIQUE ISLAMIQUE D'IRAN",
    "code": "IR"
  },
  {
    "name": "REPUBLIQUE TCHEQUE",
    "code": "CZ"
  },
  {
    "name": "REPUBLIQUE-UNIE DE TANZANIE",
    "code": "TZ"
  },
  {
    "name": "REUNION",
    "code": "RE"
  },
  {
    "name": "ROUMANIE",
    "code": "RO"
  },
  {
    "name": "ROYAUME-UNI",
    "code": "GB"
  },
  {
    "name": "RWANDA",
    "code": "RW"
  },
  {
    "name": "SAHARA OCCIDENTAL",
    "code": "EH"
  },
  {
    "name": "SAINT-BARTHELEMY",
    "code": "BL"
  },
  {
    "name": "SAINT-KITTS-ET-NEVIS",
    "code": "KN"
  },
  {
    "name": "SAINT-MARIN",
    "code": "SM"
  },
  {
    "name": "SAINT-MARTIN",
    "code": "MF"
  },
  {
    "name": "SAINT-PIERRE-ET-MIQUELON",
    "code": "PM"
  },
  {
    "name": "SAINT-SIEGE ETAT DE LA CITE DU VATICAN",
    "code": "VA"
  },
  {
    "name": "SAINT-VINCENT-ET-LES GRENADINES",
    "code": "VC"
  },
  {
    "name": "SAINTE-HELENE",
    "code": "SH"
  },
  {
    "name": "SAINTE-LUCIE",
    "code": "LC"
  },
  {
    "name": "SAMOA",
    "code": "WS"
  },
  {
    "name": "SAMOA AMERICAINES",
    "code": "AS"
  },
  {
    "name": "SAO TOME-ET-PRINCIPE",
    "code": "ST"
  },
  {
    "name": "SENEGAL",
    "code": "SN"
  },
  {
    "name": "SERBIE",
    "code": "RS"
  },
  {
    "name": "SEYCHELLES",
    "code": "SC"
  },
  {
    "name": "SIERRA LEONE",
    "code": "SL"
  },
  {
    "name": "SINGAPOUR",
    "code": "SG"
  },
  {
    "name": "SLOVAQUIE",
    "code": "SK"
  },
  {
    "name": "SLOVENIE",
    "code": "SI"
  },
  {
    "name": "SOMALIE",
    "code": "SO"
  },
  {
    "name": "SOUDAN",
    "code": "SD"
  },
  {
    "name": "SRI LANKA",
    "code": "LK"
  },
  {
    "name": "SUEDE",
    "code": "SE"
  },
  {
    "name": "SUISSE",
    "code": "CH"
  },
  {
    "name": "SURINAME",
    "code": "SR"
  },
  {
    "name": "SVALBARD ET ILE JAN MAYEN",
    "code": "SJ"
  },
  {
    "name": "SWAZILAND",
    "code": "SZ"
  },
  {
    "name": "TADJIKISTAN",
    "code": "TJ"
  },
  {
    "name": "TCHAD",
    "code": "TD"
  },
  {
    "name": "TERRES AUSTRALES FRANCAISES",
    "code": "TF"
  },
  {
    "name": "TERRITOIRE BRITANNIQUE D'OCEAN INDIEN",
    "code": "IO"
  },
  {
    "name": "TERRITOIRE PALESTINIEN OCCUPE",
    "code": "PS"
  },
  {
    "name": "THAILANDE",
    "code": "TH"
  },
  {
    "name": "TIMOR-LESTE",
    "code": "TL"
  },
  {
    "name": "TOGO",
    "code": "TG"
  },
  {
    "name": "TOKELAU",
    "code": "TK"
  },
  {
    "name": "TONGA",
    "code": "TO"
  },
  {
    "name": "TRINITE-ET-TOBAGO",
    "code": "TT"
  },
  {
    "name": "TUNISIE",
    "code": "TN"
  },
  {
    "name": "TURKMENISTAN",
    "code": "TM"
  },
  {
    "name": "TURQUIE",
    "code": "TR"
  },
  {
    "name": "TUVALU",
    "code": "TV"
  },
  {
    "name": "UKRAINE",
    "code": "UA"
  },
  {
    "name": "URUGUAY",
    "code": "UY"
  },
  {
    "name": "VANUATU",
    "code": "VU"
  },
  {
    "name": "VENEZUELA",
    "code": "VE"
  },
  {
    "name": "VIET NAM",
    "code": "VN"
  },
  {
    "name": "WALLIS ET FUTUNA",
    "code": "WF"
  },
  {
    "name": "YEMEN",
    "code": "YE"
  },
  {
    "name": "ZAMBIE",
    "code": "ZM"
  },
  {
    "name": "ZIMBABWE",
    "code": "ZW"
  }
];
